<template>
	<div>
		<v-app-bar flat app class="" style="z-index: 99;">
			<v-btn id="btn-drawerNav" text small @click.stop="clickDrawer">
				<img width="20" src="/assets/icon/toggle-list.svg" style="opacity: 0.55;" v-if="isDrawer === 60">
				<img width="20" src="/assets/icon/toggle-icon.svg" style="opacity: 0.55;" v-else>
			</v-btn>
			<v-spacer></v-spacer>

			<!-- Notif Belanja Produk -->
			<v-menu offset-y nudge-right="-255" max-height="250" max-width="300" transition="slide-y-transition" content-class="rounded-lg" v-if="countNotifTransaction >= 0">
				<template v-slot:activator="{ on, attrs }">
					<v-btn fab depressed small class="d-none d-sm-inline-flex mr-2 pl-2" v-bind="attrs" v-on="on">
						<v-badge color="primary" overlap :content="countNotifTransaction" :value="countNotifTransaction" class="mr-2">
							<v-icon class="grey--text text--darken-1">mdi-cart</v-icon>
						</v-badge>
					</v-btn>
				</template>
				<v-card width="300" height="auto" class="elevation-0">
					<template v-if="listNotificationTransaction.length > 0">
						<template v-for="notif in listNotificationTransaction">
							<v-list class="px-3 py-3 border-bottom border-grey" :key="notif.notification_id">
								<router-link class="text-deco" :to="{ name: 'detail-upload-bukti', params: {type: 'upload', slug: notif.notification_transaction_code} }">
									<div class="font-size-10 grey--text text--darken-1 font-weight-bold">{{ notif.notification_title }}</div>
									<div class="font-size-9 grey--text text--darken-1">
										<span>No. Transaksi</span>
										<span class="pl-1 font-weight-bold">{{ notif.notification_transaction_code }}</span>
										<span class="pl-1">- {{ notif.notification_description }}</span>
									</div>
									<div class="pt-2 font-size-8 blue--text text--darken-1 text-right">{{ notif.notification_datetime | tanggaljam }}</div>
								</router-link>
							</v-list>
						</template>
					</template>
					<template v-else>
						<v-list class="px-3 py-3">
							<div class="font-size-10 grey--text text--darken-1">Belum ada notifikasi transaksi yang dapat ditampilkan</div>
						</v-list>
					</template>
				</v-card>
			</v-menu>

			<!-- Notif Klaim Komisi -->
			<v-menu offset-y nudge-right="-255" max-height="250" max-width="300" transition="slide-y-transition" content-class="rounded-lg" v-if="countNotif >= 0">
				<template v-slot:activator="{ on, attrs }">
					<v-btn fab depressed small class="d-none d-sm-inline-flex mr-1 pl-2" v-bind="attrs" v-on="on">
						<v-badge color="primary" overlap :content="countNotif" :value="countNotif" class="mr-2">
							<v-icon class="grey--text text--darken-1">mdi-medal</v-icon>
						</v-badge>
					</v-btn>
				</template>
				<v-card width="300" height="auto" class="elevation-0">
					<template v-if="listNotification.length > 0">
						<template v-for="notif in listNotification">
							<v-list class="px-3 py-3 border-bottom border-grey" :key="notif.notification_id">
								<router-link class="text-deco" :to="{ name: 'klaim-komisi'}">
									<div class="font-size-10 grey--text text--darken-1 font-weight-bold">{{ notif.notification_title }}</div>
									<div class="font-size-9 grey--text text--darken-1">{{ notif.notification_description }}</div>
									<div class="pt-2 font-size-8 blue--text text--darken-1 text-right">{{ notif.notification_datetime | tanggaljam }}</div>
								</router-link>
							</v-list>
						</template>
					</template>
					<template v-else>
						<v-list class="px-3 py-3">
							<div class="font-size-10 grey--text text--darken-1">Belum ada notifikasi reward yang dapat ditampilkan</div>
						</v-list>
					</template>
				</v-card>
			</v-menu>

			<!-- Menu Dropdown -->
			<v-menu open-on-hover offset-y offset-x max-width="200" transition="slide-y-transition" content-class="rounded-lg" v-if="userData">
				<template v-slot:activator="{ on, attrs }">
					<v-btn large text class="menu-btn pl-1 pr-0 rounded-lg" v-bind="attrs" v-on="on">
						<div class="d-none d-md-block cl-grey text-right btn-user-name">
							<div class="text-capitalize">{{ userData.member_name }}</div>
							<div class="cl-primary font-weight-bold">{{ userData.member_ref_network_code }}</div>
						</div>
						<div class="d-block d-md-none cl-grey text-right btn-user-name">
							<div class="text-capitalize">{{ userData.member_name | ellipsisText(10) }}</div>
							<div class="cl-primary font-weight-bold">{{ userData.member_ref_network_code }}</div>
						</div>
						<div class="px-2">
							<v-img width="40" height="40" class="user-img rounded-pill" :src="(userData.member_image_url) ? userData.member_image_url : 'assets/image/profile-pict.png'"></v-img>
						</div>
						<v-icon color="grey darken-1">mdi-chevron-down</v-icon>
					</v-btn>
				</template>
				<v-list>
					<router-link class="text-deco" :to="{ name: 'profil'}">
						<v-list-item link>
							<v-icon small class="pr-3">mdi-account</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10">Profile</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<router-link class="text-deco" :to="{ name: 'list-upload-bukti'}">
						<v-list-item link class="d-flex d-sm-none">
							<v-icon small class="pr-3">mdi-cart</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10">List Upload</span>
									<span class="pl-1 font-size-10" v-if="countNotifTransaction > 0">({{ countNotifTransaction }})</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<router-link class="text-deco" :to="{ name: 'klaim-komisi'}">
						<v-list-item link class="d-flex d-sm-none">
							<v-icon small class="pr-3">mdi-medal</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10">Klaim Reward</span>
									<span class="pl-1 font-size-10" v-if="countNotif > 0">({{ countNotif }})</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<router-link class="text-deco" :to="{ name: 'ubah-password'}">
						<v-list-item link>
							<v-icon small class="pr-3">mdi-key-variant</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10">Ubah Password</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<v-list-item link @click.native="onLogout">
						<v-icon small class="pr-3 red--text darken-3">mdi-exit-to-app</v-icon>
						<v-list-item-content>
							<v-list-item-title>
								<span class="font-size-10 font-weight-bold red--text darken-3">Logout</span>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
	</div>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex';
// const { mapActions, mapState } = createNamespacedHelpers('auth');
import { mapState, mapActions } from 'vuex'

export default {
	data() {
		return {
			isActiveMember: false,
		}
	},
	props: ['isDrawer'],
	computed: {
		...mapState('auth', ['userData']),
		...mapState('profile', ['myProfile']),
		...mapState('notification', ['listNotification', 'statusNotification', 'listNotificationTransaction']),

		countNotifTransaction() {
			let arrNotif = []
			this.listNotificationTransaction.forEach((el) => {
				if (el.notification_status == 0) {
					arrNotif.push(el)
				}
			})
			return arrNotif.length
		},
		countNotif() {
			let arrNotif = []
			this.listNotification.forEach((el) => {
				if (el.notification_status == 0) {
					arrNotif.push(el)
				}
			})
			return arrNotif.length
		},
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		$route(to, from) {
			if (to.name == 'klaim-komisi') {
				this.readNotification().then(() => {
					this.getNotification()
				})
			} else {
				this.getNotification()
			}
		},
		statusNotification(newValue, oldValue) {
			if (newValue != oldValue) {
				this.getNotification()
			}
		},
	},
	methods: {
		...mapActions('auth', ['logout']),
		...mapActions('profile', ['getProfile', 'getProfileMitra', 'getProfilePramitra']),
		...mapActions('notification', ['getNotification', 'readNotification', 'getNotificationTransaction']),

		clickDrawer() {
			this.$emit('childToParent')
		},
		onLogout() {
			this.logout().then( () => {
				this.$router.push({ name: 'login' })
			})
		},

		gotoUpgrade() {
			this.$router.push({name: 'upgrade-kemitraan'})
		},

		gotoActivation() {
			this.$router.push({name: 'aktivasi'})
		},

		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
				else this.isActiveMember = true
			}
	},
	mounted() {
		this.getNotification()
		this.getNotificationTransaction()
	}
};
</script>
